import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { BaseApiService } from '../../../Services/base-api.service';
import { ImageUploadService } from '../../../Services/image-upload.service';
import { RichTextEditorService } from '../../../Services/rich-text-editor.service';


@Component({
  selector: 'app-add-page',
  templateUrl: './add-page.component.html',
  styleUrls: ['./add-page.component.css'],standalone:false
})
export class AddPageComponent implements OnInit{
  form!: FormGroup;
  editorContent: string = "";
  imageUrl: string = '';
  loading:boolean=false;

  constructor
  (
  private repository:BaseApiService,
  private http: HttpClient,
  private messageService:MessageService,
  private editorService: RichTextEditorService,
  private imageUploadService:ImageUploadService,

  )
{


}

  onSubmit() {
    this.loading=true
    if (this.form.valid) {

      const formValues = this.form.value;
      this.repository.create("Page", formValues).subscribe((response) => {
        this.loading=false;
        this.form.reset()
        this.messageService.add({ severity: 'success', summary: 'Success', detail: response.message });
      }
      ,(error)=>
      {
        this.loading=false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
      }
      );
    } else {
         this.loading=false;
    }


  }



 ngOnInit(): void {
  this.form = new FormGroup({
    title: new FormControl('', [Validators.required]),
    description: new FormControl('', [Validators.required]),
    metaDescription: new FormControl('', [Validators.required]),
    image:new FormControl(''),
    mainCategory:new FormControl('',[Validators.required]),
    subCategory: new FormControl('',[Validators.required])

  });

 }




upload(event: any): void {
  this.loading=true
  const file: File = event.target.files[0];
  if (file) {

   this.imageUploadService.uploadImage(file)
   .subscribe
   ((imageUrl: string) => {
     this.imageUrl = imageUrl;
     this.form.get('image')?.setValue(imageUrl);
     this.loading=false;
   }
   ,(error)=>{
    {
      this.loading=false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error });

    }
   }
   );


  }
}

}
